import { Typography } from "components/typography";
import { useTranslation } from "react-i18next";
import { useCurrentUser } from "hooks/userHooks";

const UneditableEmail = () => {
  const { t } = useTranslation();
  const { user } = useCurrentUser();

  return (
    <div>
      <Typography variant="body-x-small" color="GRAY_DARK">
        {t("EMAIL")}
      </Typography>
      <Typography
        variant="body"
        style={{ marginTop: "10px", marginBottom: "0" }}
      >
        {user?.email}
      </Typography>
    </div>
  );
};

export default UneditableEmail;
